import React from "react";
import { Box, Typography } from "@mui/material";

import { brand } from "../themes/theme";

// Sin verde (regla de marca): "info" en azul, "warn" en naranja, "neutral" en gris.
const tones = {
    info: { bg: "rgba(50,72,202,0.08)", border: "rgba(50,72,202,0.28)", color: brand.primary },
    warn: { bg: "rgba(255,95,36,0.09)", border: "rgba(255,95,36,0.32)", color: brand.accent },
    neutral: { bg: brand.gray100, border: brand.gray200, color: brand.gray600 },
};

/**
 * Etiqueta de estado compacta (Open/Published/Modelled/Blocked...).
 * @param {'info'|'warn'|'neutral'} tone
 */
function StatusTag({ children, tone = "neutral" }) {
    const t = tones[tone] || tones.neutral;
    return (
        <Box
            component="span"
            sx={{
                display: "inline-flex",
                alignItems: "center",
                px: 1,
                py: 0.25,
                borderRadius: "5px",
                border: "1px solid",
                borderColor: t.border,
                bgcolor: t.bg,
            }}
        >
            <Typography sx={{ fontSize: 10.5, fontWeight: 600, color: t.color, whiteSpace: "nowrap" }}>
                {children}
            </Typography>
        </Box>
    );
}

export default StatusTag;
